import {
	GET_SARP_SITES,
	SET_SELECTED_SARP_SITES,
	GET_SARP_SITE_TABLE,
	GET_LAST_NOP_TRACKER_UPDATE_DATE
} from '../actions/SarpReportActions';

const initialState = {
	sarpSites: [],
	selectedSarpSites: [],
	sarpSiteTable: [],
	lastNopTrackerUpdateDate: []
};

const sarpReportReducer = (state = initialState, action) => {
	switch (action.type) {
					case GET_SARP_SITES: {
						return {
							...state,
							sarpSites: action.sarpSites
						};
					}
					case SET_SELECTED_SARP_SITES: {
						return {
							...state,
							selectedSarpSites: action.selectedSarpSites
						};
					}
					case GET_SARP_SITE_TABLE: {
						return {
							...state,
							sarpSiteTable: action.sarpSiteTable
						};
					}
					case GET_LAST_NOP_TRACKER_UPDATE_DATE: {
						return {
							...state,
							lastNopTrackerUpdateDate: action.lastNopTrackerUpdateDate
						};
					}
					default: {
						return state;
					}
	}
};

export default sarpReportReducer;
